/* globals Class, lp, jui */
var jQuery = require('jquery');
var _      = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');

var ubBanzai = require('ub/control/banzai-features');

var LightboxSizeControl = require('ub/ui/lightbox-size-control');
var lightboxFactory = require('ub/lp/editor/lightbox-factory');
var endpoints = require('ub/config/endpoints').default;

var PhoneNumberActionField = require('ub/ui/properties-panel/phone-number-action-field');
var EmailActionFields = require('ub/ui/properties-panel/email-action-fields');

var ButtonFontPicker = require('ub/fonts/font-picker/button/font-picker').default;
var buttonStateController = require('ub/fonts/font-picker/button/state-controller').default;
var labelStyles = require('ub/elements/label-styles').default;

var getPreviewWarning = require('ub/ui/labels/preview-warning').default;

var tooltips = require('comp/tooltip');
var editorGoals = require('ub/lp/editor/goals');

module.exports = Class.create(
  lp.editor.panel.ElementPropertiesPanel,
  lp.editor.panel.ElementGeometryControls,
  lp.editor.panel.ElementBackgroundControlsOld,
  lp.editor.panel.ElementBorderControls,
  lp.ModuleComponent,
  {
    type:'lp-pom-button',

    initialize: function($super) {
      this.states = ['up', 'hover', 'active'];
      $super();
      var self = this;

      this.modelChangeHandlers.push(function(e) {
        self.syncUIControls(e);
      });
    },

    activate: function($super) {
      $super();
      this.handleVisibilityToggleIcon();
      tooltips.attachTooltips([{
        selector: ".tip-dtr-buttonLabel",
        copy: "You can pass in dynamic text values to your button, through your page's URL. This is useful for increasing message match and quality score of your PPC campaigns.",
        disabled: false,
        color: 'white',
        size: 'small',
        position: 'fixed'
      }]);
    },

    handleVisibilityToggleIcon: function() {
      if(this.element.isFormButton()) {
        jQuery(this.e).addClass('lp-pom-button-form');
      } else {
        jQuery(this.e).removeClass('lp-pom-button-form');
      }
    },

    _installEmailFields: function() {
      this.controls.actionModules.email = new EmailActionFields({
        container: this.controls.actionPanel.content.e,
        uiBinding: this._actionUIBinding,
        onActivate: function(emailField) {
          emailField.setValue({
            emailAddress: this.element.model.safeGet('action.emailAddress') || '',
            emailSubject: this.element.model.safeGet('action.emailSubject') || ''
          });
        }.bind(this)
      });
    },

    _installPhoneFields: function() {
      this.controls.actionModules.phone = new PhoneNumberActionField({
        container: this.controls.actionPanel.content.e,
        uiBinding: this._actionUIBinding,
        onActivate: function(phoneField) {
          phoneField.setValue(this.element.model.safeGet('action.phoneNumber') || '');
        }.bind(this)
      });
    },

    _installFontPicker: function(labelPanel) {
      if (ubBanzai.features.isFontPickerEnabled()) {
        var fontPickerContainer = document.createElement('div');

        fontPickerContainer.className = 'panel-content';

        labelPanel.e.insert(fontPickerContainer);

        ReactDOM.render(
          React.createElement(ButtonFontPicker),
          fontPickerContainer
        );

        buttonStateController.setActiveElement(this.element);
      } else {
        this.controls.font = labelPanel.insert(
          this._labelUIBinding.mkFormFontInput({ label: 'Font' })
        ); // Emits a `changeFont` event
      }
    },

    installUI: function($super){
      $super();
      var self                  = this;
      var geometryPanel         = this.insert(new jui.CollapsiblePanel({
        title:'Geometry',
        attributes: {
          className: 'collapsible-panel panel-button-geometry'
        }
      }));
      this.controls.actionPanel = this.insert(new jui.CollapsiblePanel({
        title:'Click Action',
        attributes: {
          className: 'collapsible-panel panel-button-click-action'
        }
      }));
      var labelPanel            = this.insert(new jui.CollapsiblePanel({
        title:'Button Label',
        attributes: {
          className: 'collapsible-panel panel-button-label labels-above'
        }
        }));
      var appearancePanel       = this.insert(new jui.CollapsiblePanel({
        title:'Appearance',
        attributes: {
          className: 'collapsible-panel panel-button-appearance'
        }
      }));

      this._actionUIBinding = this._uiBinding
        .mkNamespacedVersion('action')
        .subscribeDomainEvents(this.actionDomainEvents, this);

      this._labelUIBinding = this._uiBinding
        .mkNamespacedVersion('label')
        .subscribeDomainEvents(this.labelDomainEvents, this);

      this._appearanceUIBinding = this._uiBinding
        .mkNamespacedVersion('appearance')
        .subscribeDomainEvents(this.appearanceDomainEvents, this);

      this.controls.applyLabelDefaults = labelPanel.titleBar.insert(new jui.Button({
        label  : 'Reset Style',
        id     : 'use-label-defaults-button',
        attributes: {
          className: 'button link'
        },
        action : this._mkChangeHandler(this._labelUIBinding, 'setToElementDefaults')
      }));

      this.controls.applyAppearanceDefaults = appearancePanel.titleBar.insert(new jui.Button({
        label  : 'Reset Style',
        attributes: {
          className: 'button link'
        },
        id     : 'use-appearance-defaults-button',
        action : this._mkChangeHandler(this._appearanceUIBinding, 'setToElementDefaults')
      }));

      this.installGeometryControls({
        insert:geometryPanel.insertContent.bind(geometryPanel)
      });

      this.controls.buttonLabel = labelPanel.insertContent(new jui.FormDynamicContenteditable({
        label       : 'Text',
        inputStyle  : 'min-height: 48px; resize : vertical; overflow-x: hidden; overflow-y: auto',
        className   : 'help-button tip-dtr-buttonLabel',
        onkeyup: this._mkChangeHandler(this._labelUIBinding, 'changeText'),
        onblur: function(e) {
          self.element.page.undoManager.endGroup();
          self._mkChangeHandler(self._labelUIBinding, 'changeText')(e);
        },
        onfocus: function(e) {
          self.element.page.undoManager.startGroup();
          self.requestFocus(e);
        },
        afterInsert : function() {
          self._labelUIBinding.onNext({
            type  : 'changeText',
            value : self.controls.buttonLabel.getValue()
          });
        },
        uiBinding : this._uiBinding.mkNamespacedVersion('LabelDTR')
      }));

      this._installFontPicker(labelPanel);

      this.controls.action = this.controls.actionPanel.insertContent(new jui.FormSelect({
        label             : 'Action',
        id                : 'jui-button-action-select',
        dropDownClassName : 'editor-info-panel-select jui-drop-down',
        selectOptions     : [
          {name: 'Go to URL',     value: 'url'},
          {name: 'Download File', value: 'download'},
          {name: 'Submit Form',   value: 'form'}
        ],
        action: function(e) {
          self._actionUIBinding.onNext({
            type           : 'changeButtonAction',
            action         : e.source.getValue(),
            previousAction : self.element.model.get('action')
          });
        }
      }));

      /* *************************************** */
      /* JS: TODO: the various actions available for a button should be modularized */
      /* *************************************** */

      this.activeAction = 'url';
      this.controls.actionModules = {};

      this.controls.actionModules.url = {
        urlField: this.controls.actionPanel.insertContent(function() {
          var cntrl = new jui.FormLinkInput2({
            passparams   : true,
            label        : 'URL',
            onPassParams : self._mkChangeHandler(self._actionUIBinding, 'changeButtonPassParams'),
            onblur       : self._mkChangeHandler(self._actionUIBinding, 'changeButtonLink'),
            onfocus      : self.requestFocus.bind(self),
          });
          cntrl.hide();

          return cntrl;
        }()),

        warningLabel: this.controls.actionPanel.insertContent(getPreviewWarning()),

        activate: function() {
          this.urlField.show();
          this.warningLabel.show();

          var action = self.element.model.get('action');
          var value = {
            url          : action.url || '',
            target       : action.target || '',
            passparams   : Boolean(action.passparams)
          };

          this.urlField.setValue(value);
        },

        deactivate: function() {
          this.urlField.hide();
          this.warningLabel.hide();
        }
      };

      this._installEmailFields();
      this._installPhoneFields();

      this.controls.actionModules.externalLightbox = {
        urlField: this.controls.actionPanel.insertContent(function() {
          var cntrl = new jui.FormLinkInput2({
            passparams:   true,
            label:        'URL',
            hideTarget:   true,
            onPassParams: self._mkChangeHandler(self._actionUIBinding, 'changeButtonPassParams'),
            onblur:       self._mkChangeHandler(self._actionUIBinding, 'changeButtonLink'),
            onfocus:      self.requestFocus.bind(self),
          });
          cntrl.hide();

          return cntrl;
        }()),

        lightboxSizeControl: this.controls.actionPanel.insertContent(new LightboxSizeControl({
          onblur  : self._mkChangeHandler(self._actionUIBinding, 'changeExternalLightboxSize'),
          onfocus : self.requestFocus.bind(self)
        }).hide()),

        warningLabel: this.controls.actionPanel.insertContent(getPreviewWarning()),

        activate: function() {
          this.urlField.show();
          this.warningLabel.show();
          this.lightboxSizeControl.show();

          var action = self.element.model.get('action');
          var urlValue = {
            url          : action.url || '',
            target       : action.target || '',
            passparams   : Boolean(action.passparams)
          };

          var lightboxSizeValue = self.element.model.safeGet('lightboxSize') ||
            lp.module.button.ButtonElement.lightboxSizeDefault;

          this.urlField.setValue(urlValue);
          this.lightboxSizeControl.setValue(lightboxSizeValue);
        },

        deactivate: function() {
          this.urlField.hide();
          this.lightboxSizeControl.hide();
          this.warningLabel.hide();
        }
      };

      this.controls.actionModules.internalLightbox = {
        lightboxChooser: this.controls.actionPanel.insertContent(new jui.FormSelect({
          label             : 'Lightbox',
          id                : 'lightbox-chooser',
          dropDownClassName : 'editor-info-panel-select jui-drop-down lightbox-chooser-dropdown',
          autoWidth         : true,
          action            : self._mkChangeHandler(self._actionUIBinding, 'changeLightboxPage')
        })).hide(),
        editLightboxButton: this.controls.actionPanel.insertContent(new jui.Button({
          label      : 'Edit Lightbox',
          action     : self._mkChangeHandler(self._actionUIBinding, 'editLightbox'),
          classNames : ['full-width-button']
        }).hide()),

        activate: function() {
          self._syncInternalLightboxControls();
          this.lightboxChooser.show();
        },

        deactivate: function() {
          this.lightboxChooser.hide();
          this.editLightboxButton.hide();
        }
      };

      this.controls.actionModules.download = {
        chooseDownloadAssetButton: this.controls.actionPanel.insertContent( function() {
          var cntrl = new jui.FormAssetChooser({
            label        : 'File',
            chooseLabel  : 'Upload New Files',
            changeAction : function() {
              window.editor.openAssetChooser({
                url               : endpoints.assetsByCompanyId(window.editor.currentCompanyId),
                activeTab         : 'documents',
                visibleTabs       : ['images', 'documents', 'media', 'other'],
                onlyImages        : false,
                title             : 'Choose a File',
                uploadButtonLabel : 'Upload New Files',
                onChoose          : function(file){
                  self._actionUIBinding.onNext({
                    type : 'changeButtonFileDownload',
                    file : file
                  });
                },
                selectedAsset: self.element.model.exists('action.asset') ?
                  self.element.model.get('action.asset') :
                  null
              });
            }
          });
          cntrl.hide();
          return cntrl;
        }()),

        setAsset: function(asset) {
          this.chooseDownloadAssetButton.setAsset(asset);
          self.performModelUpdates(function() {
            var um = self.element.page.undoManager;
            um.startGroup();
            self.element.model.set('action.type', 'download', um);
            self.element.model.set('action.asset', {
              id                   : asset.id,
              uuid                 : asset.uuid,
              content_url          : asset.content_url,
              unique_url           : asset.unique_url,
              content_content_type : asset.content_content_type,
              name                 : asset.name,
              protected_download   : self.element.page.usedAs() === 'form_confirmation'
            }, um);
            um.endGroup();
          });
        },

        activate: function(action, previous) {
          this.chooseDownloadAssetButton.show();
          if (action === null) {
            window.editor.openAssetChooser({
              url: endpoints.assetsByCompanyId(window.editor.currentCompanyId),
              title: 'Choose a File',
              activeTab: 'documents',
              visibleTabs: ['images', 'documents', 'media', 'other'],
              onlyImages: false,
              uploadButtonLabel: 'Upload New Files',
              onChoose: function(file) {
                self._actionUIBinding.onNext({
                  type : 'changeButtonFileDownload',
                  file : file
                });
              },
              onCancel: function() {
                self._actionUIBinding.onNext({
                  type     : 'cancelButtonFileDownload',
                  previous : previous
                });
              },
              selectedAsset: self.element.model.exists('action.asset') ?
                self.element.model.get('action.asset') :
                null
            });
          } else {
            this.chooseDownloadAssetButton.setAsset(action.asset);
          }
        },
        deactivate: function() {
          this.chooseDownloadAssetButton.hide();
          this.chooseDownloadAssetButton.setAsset(null);
        }
      };

      this.controls.actionModules.form = {
        activate   : function(){},
        deactivate : function(){}
      };

      // Activating or deactivating the 'close' action doesn't require any additional
      // controls to be shown or hidden, so these functions can be no-ops.
      this.controls.actionModules.close = {
        activate   : function() {},
        deactivate : function() {}
      };

      this.controls.fill = appearancePanel.insertContent(new jui.FormSelect({
        label             : 'Style',
        id                : 'jui-button-style-select',
        dropDownClassName : 'editor-info-panel-select jui-drop-down',
        selectOptions     : [
          {name: 'Solid Color', value:'solid'},
          {name: 'Gradient',    value:'gradient'},
          {name: 'Image',       value:'image'}
        ],
        action: this._mkChangeHandler(this._appearanceUIBinding, 'changeStyle')
      }));

      this.controls.tabs = appearancePanel.insertContent(new jui.Component({
        attributes: { className: 'button-state-tabs tab-bar clearfix' }
      }));

      var rg = null;
      var firstState = this.states[0];
      // JS: For each button state add the following ways to change appearance
      this.states.each(function(s) {
        // JS: add the tab button corresponding to this state

        this.controls[s] = {};

        this.controls[s].tab = this.controls.tabs.insert(new jui.RadioButton({
          label      : s.capitalize(),
          radioGroup : rg,
          action     : this._mkChangeHandler(this._appearanceUIBinding,
            'changeStateTab', s),
          attributes : {className:'tab'}
        }));
        rg = rg || this.controls[s].tab.group;

        var panel = this.controls[s+'Panel'] = appearancePanel.insertContent(new jui.Component({
          attributes: { className: 'special-panel clearfix' }
        }));

        if (s !== firstState) {
          this.controls[s].auto = panel.insert(new jui.FormCheckboxInput({
            label   : 'Create appearance based on "Up" state',
            inputId : s + '-auto-checkbox',
            onclick : this._mkChangeHandler(this._appearanceUIBinding,
              'changeAutoGenerateState', s)
          }));
        }

        this.controls[s].bkgColor = panel.insert(new jui.FormColorInput({
          label   : 'Underlay Color',
          onblur  : this._mkChangeHandler(this._appearanceUIBinding,
            'changeBackgroundColor', s),
          onfocus : this.requestFocus.bind(this)
        }));

        this.controls[s].opacity = panel.insert(new jui.FormSliderInput({
          label    : 'Underlay Opacity',
          onfocus  : this.requestFocus.bind(this),
          onchange : this._mkChangeHandler(this._appearanceUIBinding,
            'changeBackgroundOpacity', s),
          startTracking: function() {
            var model = self.element.model;
            var undoManager = self.element.page.undoManager;
            var propertyName = 'style.' + s + '.opacity';
            undoManager.registerUndo({
              action: model.set,
              receiver: model,
              params: [
                propertyName,
                model.exists(propertyName) ? model.get(propertyName) : 100,
                undoManager
              ]
            });
          },
          slider: {
            min: 0,
            max: 100,
            increment: 1
          }
        }));

        this.controls[s].baseColor = panel.insert(new jui.FormColorInput({
          label   : 'Base Color',
          onblur  : this._mkChangeHandler(this._appearanceUIBinding, 'changeBaseColor', s),
          onfocus : this.requestFocus.bind(this)
        }));

        this.controls[s].fromColor = panel.insert(new jui.FormColorInput({
          label      : 'Top',
          onblur     : this._mkChangeHandler(this._appearanceUIBinding,
            'changeFromColor', s),
          onfocus    : this.requestFocus.bind(this),
          classNames : ['top-cap']
        }));

        this.controls[s].toColor = panel.insert(new jui.FormColorInput({
          label   : 'Bottom',
          onblur  : this._mkChangeHandler(this._appearanceUIBinding, 'changeToColor', s),
          onfocus : this.requestFocus.bind(this)
        }));

        this.controls[s].reverse = this.controls[s].fromColor.insert(new jui.ToggleButton({
          action     : this._mkChangeHandler(this._appearanceUIBinding,
            'reverseGradient', s),
          classNames : ['reverse-gradient svg-ico-reverse-icon'],
          toolTip    : 'Swap gradient colors'
        }));

        // JS: change the image
        this.controls[s].changeImageButton = panel.insert(new jui.FormAssetChooser({
          label        : s.capitalize() + ' Image',
          noFileText   : 'Same as Up image',
          changeAction : window.editor.openAssetChooser.bind(window.editor, {
            onlyImages : true,
            onChoose   : function(imageData) {
              self._appearanceUIBinding.onNext({
                type  : 'changeBackgroundImage',
                value : imageData,
                state : s
              });
            }
          }),
          chooseLabel  : 'Change Image',
          changeLabel  : 'Change Image',
        }));

        if (s === 'up') {
          this.controls.highlight = panel.insert(new jui.FormCheckboxInput({
            label   : 'Show inner highlight',
            inputId : s + '-hightlight-checkbox',
            attributes: {
              'className': 'form-elm checkbox-input highlight-checkbox'
            },
            onclick : this._mkChangeHandler(this._appearanceUIBinding,
              'changeInnerHighlight', s)
          }));

          this.controls.fitToImageCheckbox = panel.insert(new jui.FormCheckboxInput({
            label   : 'Fit button to image',
            inputId : s + '-fix-to-image-checkbox',
            onclick : this._mkChangeHandler(this._appearanceUIBinding, 'enableFitImage')
          }));
        }

        // TODO Move into labelPanel
        // JS: change the text color
        this.controls[s].textColor = panel.insert(new jui.FormColorInput({
          label   : 'Text Color',
          onblur  : this._mkChangeHandler(this._appearanceUIBinding, 'changeTextColor', s),
          onfocus : this.requestFocus.bind(this)
        }));

        // JS: change the border style
        this.controls[s].border = panel.insert( new jui.FormBorderInput({
          onblur       : this._mkChangeHandler(this._appearanceUIBinding, 'changeBorder', s),
          onfocus      : this.requestFocus.bind(this),
          disableWidth : s !== firstState,
          disableStyle : s !== firstState
        }));

        if (s === 'up'){
          this.controls.cornerRadius = panel.insert(new jui.FormSliderInput({
            label         : 'Corner Radius',
            onchange      : this._mkChangeHandler(this._appearanceUIBinding,
              'changeCornerRadius', s),
            onfocus       : this.requestFocus.bind(this),
            startTracking : function() {
              var m   = self.element.model,
                  um  = self.element.page.undoManager,
                  rad = m.exists('geometry.cornerRadius') ? m.get('geometry.cornerRadius') : 0;
              um.registerUndo({
                action   : m.set,
                receiver : m,
                params   : ['geometry.cornerRadius', rad, um]
              });
            },
            slider: {
              min: 0,
              max: 100,
              increment: 1
            }
          }));
        }

        panel.hide();
      }, this);

      // JS: for now the autoGradient property can only be set on the up state and is applied the same to remaining states

      this.controls.autoGradient = this.controls.up.fromColor.insert(new jui.ToggleButton({
        action     : function(e) {
          self._appearanceUIBinding.onNext({
            type  : 'changeAutoGradient',
            value : !e.source.isSelected()
          });
        },
        classNames : ['lock-gradient svg-ico-lock-locked-2'],
        toolTip    : 'Customize gradient colors'
      }));

      this.controls.textShadow = this.controls.up.textColor.insert(
        new Element('input', {
          type: 'checkbox',
          className: 'form-elm-checkbox-no-wrap text-shadow-input',
          id: 'text-shadow-checkbox'
        })
      );

      this.controls.textShadowLabel = this.controls.up.textColor.insert(
        new Element('label', {
          className: 'separate',
          htmlFor: 'text-shadow-checkbox'
        }).update('Text Shadow')
      );

      this.controls.textShadow.observe('click', function(e) {
        self._appearanceUIBinding.onNext({
          type  : 'changeTextShadow',
          value : e.target.checked
        });
      });

      this.controls.commonAppearanceControls = appearancePanel.insertContent(new jui.Component());

      this._changeStatePanel('up');
    },

    _mkChangeHandler: function(uiBinding, eventType, state) {
      return function changeHandler(e) {
        var eventParams = { type: eventType };

        if (e.source && _.isFunction(e.source.getValue)) {
          eventParams.value = e.source.getValue();
        }

        if (state) {
          eventParams.state = state;
        }

        if (e.slider) {
          eventParams.sliderTracking = e.slider.tracking;
        }

        uiBinding.onNext(eventParams);
      };
    },

    syncUIControls: function($super) {
      $super();
      var accessor = '';
      if(arguments[1] && arguments[1].data && arguments[1].data.accessor) {
        accessor = arguments[1].data.accessor;
      }
      this.syncAppearanceControls(accessor);
      this.syncActionControls(accessor);
      this.syncLabelControls(accessor);
      this.bindGeometryControlsToElement(this.element);
    },

    syncActionControls: function(accessor) {
      if (accessor === 'geometry.offset') { return; }

      var model   = this.element.model;
      var action  = model.safeGet('action') || {type: 'url'};
      var options = [];

      if (model.exists('constraints.allowActions')) {
        // Form submit buttons
        // TODO: Review this branch. Form submit buttons can't have a 'Go to URL' action
        // so is any of this necessary?
        var allow = model.get('constraints.allowActions');
        if (allow.include('url')){
          options.push({name:'Go to URL', value:'url'});
        }
        if (allow.include('form') && this.element.page.hasForm()) {
          options.push({name:'Submit Form', value:'form'});
        }

        // Hide the entire panel if there is only one allowed action (form submit buttons
        // only)
        if (allow.length < 2) {
          this.controls.actionPanel.hide();
        } else {
          this.controls.actionPanel.show();
        }
      } else {
        // Regular buttons
        options = this._buildActionOptions();
        this.controls.actionPanel.show();

        // This is a fallback if we turn off the internal lightbox feature flag for a
        // user already using the feature
        // TODO: Remove the code below when removing the feature flag `internalLightboxes`
        if (action.type === 'internalLightbox' &&
          ! this.element.page.getConfigValue('allowInternalLightboxes')) {
            model.set('action.type', 'url');
            model.deleteAttr('action.lightboxId');
            action = model.safeGet('action');
        }
      }

      // Hide the action control if it only contains the URL option
      if (options.length === 1 && options[0].value === 'url') {
        this.controls.action.hide();
      } else {
        this.controls.action.show();
      }

      // Update the action dropdown
      this.controls.action.setSelectOptions(options);
      this.controls.action.setSelectedValue(action.type);

      // Show the relevant action module
      if (this.activeAction !== action.type) {
        this.getActionModule(this.activeAction).deactivate();
        this.activeAction = action.type;
      }

      this.getActionModule(action.type).activate(action);
    },

    _buildActionOptions: function() {
      var options = [{
        name:'Go to URL',
        value: 'url'
      }];

      if (this.element.page.isFormConfirmation()) {
        options.push({name:'Download File', value: 'download'});
      }

      if (this.element.page.allowExternalLightboxes()) {
        options.push({name:'Go to URL in Lightbox', value: 'externalLightbox'});
      }

      if (this.element.page.getConfigValue('allowInternalLightboxes')) {
        options.push({name:'Show a Lightbox', value: 'internalLightbox'});
      }

      options.push({
        name: 'Call a number',
        value: 'phone'
      });

      options.push({
        name: 'Send an email',
        value: 'email'
      });

      if (this.element.page.getConfigValue('allowButtonCloseClickAction')) {
        options.push({
          name: 'Close on click',
          value: 'close'
        });
      }

      return options;
    },

    getActionModule: function(actionType) {
      var actionModule = this.controls.actionModules[actionType];

      // If the model action type doesn't match an available panel action module, for
      // example a lightbox element with the feature flag subseqently turned off, fall
      // back to 'Go to URL'
      if ( ! actionModule ) { actionModule = this.controls.actionModules.url; }

      return actionModule;
    },

    _syncInternalLightboxControls: function() {
      var self = this;
      var controls = this.controls.actionModules.internalLightbox;

      // The jui control expects string values so we explicity coerce the lightboxId
      // Number to a String. When setting the model value in the change handler, we coerce
      // it back to a Number
      var pageRefId = String(this.element.model.safeGet('action.lightboxId') || '');

      // Build option list for lightbox chooser dropdown
      var selectOptions = [{name : 'Choose a lightbox', value: ''}];
      selectOptions = selectOptions.concat(
        _(window.editor.findPagesUsedAs('lightbox'))
          .filter(function(page) {
            return page !== self.element.page;
          })
          .map(function(page) {
            return {name: page.name, value: String(page.getRefId())};
          })
          .value()
      );

      if ( ! lp.isLightboxLimitReached()) {
        selectOptions.push({name: '+ Create lightbox', value: '_create_lightbox'});
      } else {
        selectOptions.push({name: 'Lightbox limit reached', value: '_limit_reached'});
      }

      // Update lightbox chooser dropdown
      controls.lightboxChooser.setSelectOptions(selectOptions);
      controls.lightboxChooser.setSelectedValue(pageRefId);

      // Update edit button visibility
      controls.editLightboxButton[pageRefId ? 'show' : 'hide']();
    },

    syncLabelControls: function() {
      if(arguments[0] === 'geometry.offset') { return; }

      var model = this.element.model;

      this.controls.buttonLabel.setValue(model.safeGet('content.label') || '');

      if (ubBanzai.features.isFontPickerEnabled()) {
        buttonStateController.setActiveElement(this.element);
      } else {
        this.controls.font.setValue({
          family: model.safeGet('style.fontFamily') || 'arial',
          weight: model.safeGet('style.fontWeight') || 'normal',
          size: model.safeGet('style.fontSize') || ''
        });
      }

      this.controls.textShadow.setValue(model.safeGet('style.textShadow') || false);
    },

    setFillControlsVisibility: function(state, fillType, auto) {
      var isSolid = fillType === 'solid';
      var isGradient = fillType === 'gradient';
      var isImage = fillType === 'image';

      if (state !== 'up') {
        this.controls[state].auto.setVisible(true);
      }

      this.controls[state].bkgColor.setVisible((isSolid || isImage) && !auto);
      this.controls[state].opacity.setVisible((isSolid || isImage) && !auto);

      this.controls[state].baseColor.setVisible((isGradient) && !auto);

      this.controls[state].fromColor.setVisible(isGradient && !auto);
      this.controls[state].toColor.setVisible(isGradient && !auto);

      this.controls[state].changeImageButton.setVisible(isImage);
      this.controls[state].textColor.setVisible(!auto || isImage);
      this.controls[state].border.setVisible(!auto || isImage);
      this.controls.highlight.setVisible(!isImage);
      this.controls.textShadow[isImage ? 'hide' : 'show']();
      this.controls.textShadowLabel[isImage ? 'hide' : 'show']();
    },

    syncAppearanceControls: function() {
      if(arguments[0] === 'geometry.offset') { return; }
      var m = this.element.model;
      var fillType = this.element.getCurrentFillType();
      var upBorder = m.exists('style.up.border') ? m.get('style.up.border') : null;

      if (this.controls.fill.getValue() !== fillType) {
        this.controls.fill.setSelectedValue(fillType);
      }

      this.states.each(function(state) {
        var autoGenerate = m.exists('style.'+state+'.auto') && m.get('style.'+state+'.auto');

        if (state !== 'up') {
          this.controls[state].auto.setValue(autoGenerate);
        }

        if (!autoGenerate || fillType === 'image') {
          this['sync'+fillType.capitalize().camelize()+'FillControls'](state);
        }

        this.setFillControlsVisibility(state, fillType, autoGenerate, m);

        this.controls[state].textColor.setValue((m.exists('style.'+state+'.color') ? m.get('style.'+state+'.color') : m.get('style.up.color')));

        //JS: always use the border width from the up border
        if (upBorder === null) {
          this.controls[state].border.setValue(null);
        } else{
          var border = m.exists('style.'+state+'.border') ? m.get('style.'+state+'.border') : null;

          this.controls[state].border.setValue({
              style: upBorder.style,
              width: upBorder.width,
              color: border === null ? upBorder.color : border.color
            });
        }

      }, this);

      this.controls.autoGradient.setSelected(!(m.exists('style.autoGradient') ? m.get('style.autoGradient') : false));
      this.controls.highlight.setValue(m.exists('style.highlight') && m.get('style.highlight'));
      this.controls.cornerRadius.setValue(m.exists('geometry.cornerRadius') ? m.get('geometry.cornerRadius') : 0);

      var self = this;

      if (fillType === 'image') {
        var fitToCheckbox = this.controls.fitToImageCheckbox;
        fitToCheckbox.setVisible(true);

        var imageUrl = m.safeGet('style.up.image.content_url');
        if (imageUrl) {
          jui.utils.loadImage(imageUrl, function(img) {
            var size   = m.get('geometry.size');
            var fitted = img.width === size.width && img.height === size.height;
            fitToCheckbox.setValue(fitted);
            fitToCheckbox.checkbox.disabled = fitted;
          });
        }
      } else {
        self.controls.fitToImageCheckbox.setVisible(false);
      }
    },

    syncSolidFillControls: function(state) {
      var m           = this.element.model;
      var bgColPath   = 'style.'+state+'.backgroundColor';
      var opacityPath = 'style.'+state+'.opacity';
      var bgCol       = m.exists(bgColPath) ? m.get(bgColPath) : 'transparent';
      var opacity     = m.exists(opacityPath) ? parseInt(m.get(opacityPath), 10) : 100;

      this.controls[state].bkgColor.setValue(bgCol);

      if (bgCol === 'transparent') {
        this.controls[state].bkgColor.setValue(m.getSavedBackgroundColor(state));
        m.set(bgColPath, m.getSavedBackgroundColor(state));
        m.set(opacityPath, 0);
        opacity = 0;
      }
      this.controls[state].opacity.setValue(opacity);
    },

    gradientByStateAndBGColor: function(state, bgCol) {
      return state === 'active' && this.controls.active.auto.checked ?
        this.element.generateGradientByState('active').gradient :
          this.element.model.calculateGradient(bgCol);
    },

    syncGradientFillControls: function(state) {
      var m = this.element.model;
      var bgColPath = 'style.'+state+'.backgroundColor';
      var bgCol = m.exists(bgColPath) && m.get(bgColPath) !== 'transparent' ?
                  m.get(bgColPath) :
                  m.getSavedBackgroundColor(state);
      var autoGradient = m.exists('style.autoGradient') && m.get('style.autoGradient');

      var g = this.gradientByStateAndBGColor(state, bgCol);

      var gradient = autoGradient ? g : m.get('style.'+state+'.gradient');
      var reverse = m.exists('style.'+state+'.reverseGradient') && m.get('style.'+state+'.reverseGradient');

      var from = reverse ? gradient.to : gradient.from;
      var to = reverse ? gradient.from : gradient.to;

      this.controls[state].baseColor.setValue(bgCol);

      this.controls[state].baseColor.setEnabled(autoGradient);

      this.controls[state].fromColor.setValue(from);
      this.controls[state].toColor.setValue(to);

      this.controls[state].fromColor.setEnabled(!autoGradient);
      this.controls[state].toColor.setEnabled(!autoGradient);
      this.controls[state].reverse.checked = reverse;
    },

    syncAutoGradientFillControls: function(state) {
      var m = this.element.model;
      var reversePath = 'style.'+state+'.reverseGradient';
      this.syncSolidFillControls(state);
      this.controls[state].reverse.checked = m.exists(reversePath) && m.get(reversePath);
    },

    syncCustomGradientFillControls: function(state) {
      var m = this.element.model;
      var fill = m.get('style.'+state+'.gradient');
      this.controls[state].fromColor.setValue(fill.from);
      this.controls[state].toColor.setValue(fill.to);
    },

    syncImageFillControls: function(state) {
      var m = this.element.model;
      var imgPath = 'style.'+state+'.image';
      var bgColPath = 'style.'+state+'.backgroundColor';
      var opacityPath = 'style.'+state+'.opacity';

      var button = this.controls[state].changeImageButton;
      var bgCol = m.exists(bgColPath) ? m.get(bgColPath) : 'transparent';
      var opacity = m.exists(opacityPath) ? parseInt(m.get(opacityPath), 10) : 100;

      if (bgCol === 'transparent') {
        this.controls[state].bkgColor.setValue(m.getSavedBackgroundColor(state));
        m.set(bgColPath, m.getSavedBackgroundColor(state));
        m.set(opacityPath, 0);
        opacity = 0;
      }
      this.controls[state].opacity.setValue(opacity);

      var img = m.safeGet(imgPath);
      if (img) {
        button.setAsset(img);
        this.controls[state].image = img.content_url;
      } else {
        button.setAsset(null);
        this.controls[state].image = null;
      }
      this.syncSolidFillControls(state);
    },

    deactivated: function() {
      // When we select another element, ensure the button on the canvas is returned to
      // its 'up' state
      if (this.element) {
        this.activeState = 'up';
        this.element.updateCSSRules();
      }
      tooltips.removeTooltips([{
        selector: ".tip-dtr-buttonLabel"
      }]);
    },

    setElement: function($super, elm) {
      if (this.element) {
        this.element.removeListener('deactivated', this);
      }
      $super(elm);
      elm.addListener('deactivated', this);
      this._changeStatePanel('up');
    },

    _changeStatePanel: function(state) {
      // TODO: Are we updating all the properties on this.controls[state]? Maybe we can
      // .merge or completely overwrite the prop hash and reduce the lines of code
      this.controls[state].tab.makeActive();

      if (this.controls.currentPanel){
        this.controls.currentPanel.hide();
      }

      this.controls.currentPanel = this.controls[state+'Panel'];
      this.controls.currentPanel.show();
      this.activeState = state;

      if (this.element) {
        this.element.updateCSSRules();
      }

      this.controls[state].fromColor.insert(this.controls.autoGradient);
      this.controls[state].opacity.updateKnob();

      this.controls[state].textColor.insert(this.controls.textShadow);
      this.controls[state].textColor.insert(this.controls.textShadowLabel);

      if (state !== 'up') {
        this.controls.autoGradient.disable();
        this.controls.textShadow.disabled = true;
        this.controls.textShadowLabel.addClassName('disabled');
      } else {
        this.controls.autoGradient.enable();
        this.controls.textShadow.disabled = false;
        this.controls.textShadowLabel.removeClassName('disabled');
      }
    },

    _updateActionFieldValue: function(propertyName, actionValue) {
      this.performModelUpdates(function() {
        var um = this.element.page.undoManager;

        um.startGroup();

        this.element.model.set(propertyName, actionValue, um);

        um.endGroup();

      }.bind(this));
    },

    _setActionType: function(type) {
      this.performModelUpdates(function() {
        this.element.model.set('action.type', type, this.element.page.undoManager);
      }.bind(this));
    },

    labelDomainEvents: {
      setToElementDefaults: function() {
        this.element.model.applyLabelDefaults();
      },

      changeFont: function(ev) {
        this.updatingModel = true;
        this.element.model.setFont(ev.value);
        this.updatingModel = false;
      },

      changeText: function(ev) {
        this.updatingModel = true;
        if (ev.value === '') {
          this.element.model.deleteAttr('content.label', this.element.page.undoManager);
        } else {
          var textStyles = this.element.model.safeGet('style.textStyles');
          var newContent = labelStyles.getLabelHtml(textStyles, ev.value);
          this.element.model.set('content.label', ev.value);
          this.element.label.innerHTML = newContent;
        }
        this.updatingModel = false;

        if (this.controls.buttonLabel.getValue() !== ev.value) {
          this.controls.buttonLabel.setValue(ev.value); // Sync control
        }
      }
    },

    actionDomainEvents: {
      changeButtonAction: function(ev) {
        this._setActionType(ev.action);

        if(ev.action === "externalLightbox") {
          jQuery(window).trigger('externalLightboxSelected');
        }

        this.getActionModule(this.activeAction).deactivate();
        this.getActionModule(ev.action).activate(null, ev.previousAction);
        this.activeAction = ev.action;
        this.controls.action.setSelectedValue(ev.action); // Sync control

        var name = this.element.model.safeGet('name') || '';

        if (ev.action === 'externalLightbox' || ev.action === 'internalLightbox' ) {
          if (name.substr(0, 6) === 'Button') {
            this.element.model.set('name',
            window.editor.page.generateDefaultElementName('lp-pom-button', 'Lightbox Button'));
          }
        } else if (name.substr(0, 15) === 'Lightbox Button') {
          this.element.model.set('name',
          window.editor.page.generateDefaultElementName('lp-pom-button', 'Button'));
        }
        this.syncTitlePanel();
      },

      changeExternalLightboxSize: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('lightboxSize', ev.value, self.element.page.undoManager);
        });
        this.controls.actionModules.externalLightbox.lightboxSizeControl.setValue(ev.value); // Sync control
      },

      changeLightboxPage: function(ev) {
        var lightboxId;

        var um = this.element.page.undoManager;
        um.startGroup();

        if (ev.value === '_limit_reached') {
          // Revert to previous value
          this._syncInternalLightboxControls();
          return;
        } else if (ev.value === '_create_lightbox') {
          jQuery(window).trigger({
            type        : 'createdInternalLightbox',
            createdUsing : 'button dropdown'
          });

          var lightboxPage = lightboxFactory.createLightbox(window.editor);
          window.editor.addPage(lightboxPage);
          lightboxId = lightboxPage.getRefId();
        } else {
          // The control returns String values so we need to coerce that back to a Number
          lightboxId = ev.value ? parseInt(ev.value, 10) : ev.value;
        }

        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('action.type', 'internalLightbox', um);
          self.element.model.set('action.lightboxId', lightboxId, um);
        });

        um.endGroup();

        this._syncInternalLightboxControls();
      },

      editLightbox: function(/* ev */) {
        var pageRefId = this.element.model.safeGet('action.lightboxId');
        var lightboxPage = window.editor.findPageByRefId(pageRefId);

        if (lightboxPage) {
          window.editor.setActivePage(lightboxPage);
        }
      },

      changeButtonLink: function(ev) {
        var self = this;

        this.performModelUpdates(function() {
          var um = self.element.page.undoManager;
          um.startGroup();

          var autoEnableGoal = editorGoals.shouldAutoEnableGoal(window.editor, self.element);

          self.element.model.set('action.url', ev.value.url, um);
          self.element.model.set('action.target', ev.value.target, um);
          self.element.model.set('action.passparams', ev.value.passparams, um);

          var newGoal = editorGoals.getElmGoal(self.element)[0];

          if (!_.isEmpty(newGoal) && autoEnableGoal) {
            editorGoals.addActiveGoalForAllPages(window.editor, newGoal, true);
          }

          editorGoals.updateAndSyncGoals(window.editor);

          um.endGroup();
        });

        this.getActionModule(this.controls.action.getValue()).urlField.setValue(ev.value); // Sync control
      },

      changeEmailAddress: function(ev) {
        this._updateActionFieldValue('action.emailAddress', ev.value);
      },

      changeEmailSubject: function(ev) {
        this._updateActionFieldValue('action.emailSubject', ev.value);
      },

      changePhoneNumber: function(ev) {
        this._updateActionFieldValue('action.phoneNumber', ev.value);
      },

      changeButtonPassParams: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('action.passparams', ev.value, self.element.page.undoManager);
        });
      },

      changeButtonFileDownload: function(ev) {
        this.controls.actionModules.download.setAsset(ev.file);
      },

      cancelButtonFileDownload: function(ev) {
        if (ev.previous) {
          this.element.model.set('action', ev.previous);
          if (ev.previous.type !== 'download') {
            this.controls.actionModules.download.chooseDownloadAssetButton.hide();
            this.controls.actionModules.download.chooseDownloadAssetButton.setAsset(null);
          }
        }
      }
    },


    appearanceDomainEvents: {
      setToElementDefaults: function() {
        this.element.model.applyAppearanceDefaults();
      },

      changeStyle: function(ev) {
        var self = this;

        if (ev.value === 'image') {
          window.editor.openAssetChooser({
            onlyImages: true,
            onChoose: function(imageData) {
              self._appearanceUIBinding.onNext({
                type  : 'changeBackgroundImage',
                value : imageData
              });
              self._changeStatePanel('up');
            },
            onCancel: function() {
              self._appearanceUIBinding.onNext({
                type     : 'cancelStyleChange',
                previous : self.element.getCurrentFillType()
              });
            }
          });
        } else {
          this.element.model.setFillType(ev.value);
        }
      },

      cancelStyleChange: function(ev) {
        this.controls.fill.setSelectedValue(ev.previous);
      },

      changeStateTab: function(ev) {
        this._changeStatePanel(ev.state);
      },

      changeAutoGenerateState: function(ev) {
        this.element.model.setAutoGenerateState(ev.value, ev.state);
      },

      changeBaseColor: function(ev) {
        var bgCol = ev.value || 'transparent';
        this.element.model.setBackgroundColor(bgCol, ev.state);
      },

      reverseGradient: function(ev) {
        var m = this.element.model;
        var reversed = m.exists('style.'+ ev.state +'.reverseGradient') ?
          m.get('style.' + ev.state + '.reverseGradient') : false;
        m.set('style.' + ev.state + '.reverseGradient', !reversed);
      },

      changeAutoGradient:function(ev) {
        this.element.model.setAutoGradient(ev.value);
      },

      changeFromColor: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.setGradientColor({
            from : ev.value,
            to   : self.controls[ev.state].toColor.getValue()
          }, ev.state);
        });
        this.controls[ev.state].fromColor.setValue(ev.value); // Sync control
      },

      changeToColor: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.setGradientColor({
            from : self.controls[ev.state].fromColor.getValue(),
            to   : ev.value
          }, ev.state);
        });
        this.controls[ev.state].toColor.setValue(ev.value); // Sync control
      },

      changeTextColor: function(ev) {
        this.updatingModel = true;
        var col = ev.value;
        if (col !== '') {
          this.element.model.set('style.'+ ev.state +'.color', col, this.element.page.undoManager);
        } else {
          this.element.model.deleteAttr('style.'+ ev.state +'.color', this.element.page.undoManager);
        }
        this.updatingModel = false;
        this.controls[ev.state].textColor.setValue(ev.value); // Sync control
      },

      changeBorder: function(ev) {
        var self = this;
        this.performModelUpdates(function() {
          self.element.model.set('style.'+ ev.state +'.border', Object.clone(ev.value), self.element.page.undoManager);
        });

        if ( ! _.isEqual(ev.value, this.controls[ev.state].border.getValue())) {
          this.controls[ev.state].border.setValue(ev.value); // Sync control
        }
      },

      changeInnerHighlight: function(ev) {
        this.element.model.set('style.highlight', ev.value, this.element.page.undoManager);
      },

      changeCornerRadius: function(ev) {
        var self = this;
        this.performModelUpdates( function(){
          self.element.model.set('geometry.cornerRadius', ev.value, ev.tracking ? null : self.element.page.undoManager);
        });
        this.controls.cornerRadius.setValue(ev.value); // Sync control
      },

      changeTextShadow: function(ev) {
        this.element.model.set('style.textShadow', ev.value, this.element.page.undoManager);
      },

      changeBackgroundColor: function(ev) {
        var bgCol = ev.value || 'transparent';
        this.element.model.setBackgroundColor(bgCol, ev.state);
      },

      changeBackgroundOpacity: function(ev) {
        this.element.model.setOpacity(ev.value, ev.state);
      },

      changeBackgroundImage: function(ev) {
        this.element.model.setImage(ev.value, ev.state);
      },

      enableFitImage: function() {
        this.element.model.fitToImage();
      }
    }
  }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-button/button_element_properties_panel.js
// module id = 1454
// module chunks = 0